import type { IResourceItem } from "@refinedev/core";
import {
  DashboardOutlined,
  MessageOutlined,
  CheckSquareOutlined,
  FileTextOutlined,
  BookOutlined,
  SettingOutlined,
  StopOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";

export const resources: IResourceItem[] = [
  {
    name: "dashboard",
    list: "/",
    meta: { label: "Главная", icon: <DashboardOutlined /> },
  },
  {
    name: "reviews",
    list: "/reviews",
    show: "/reviews/:id",
    meta: { label: "Отзывы", icon: <MessageOutlined /> },
  },
  {
    name: "strategies",
    list: "/strategies",
    create: "/strategies/create",
    edit: "/strategies/:id",
    meta: { label: "Правила маршрутизации", icon: <CheckSquareOutlined /> },
  },
  {
    name: "templates",
    list: "/templates",
    create: "/templates/create",
    edit: "/templates/edit/:id",
    meta: { label: "Шаблоны ответов", icon: <FileTextOutlined /> },
  },
  {
    name: "knowledge-base",
    list: "/kb",
    create: "/kb/create",
    edit: "/kb/edit/:id",
    meta: { label: "База знаний", icon: <BookOutlined /> },
  },
  {
    name: "stop-words",
    list: "/stop-words",
    create: "/stop-words/create",
    edit: "/stop-words/edit/:id",
    meta: { label: "Стоп-слова", icon: <StopOutlined /> },
  },
  {
    name: "stop-word-categories",
    meta: { hide: true },
  },
  {
    name: "settings/ai-styles",
    list: "/settings/ai-styles",
    create: "/settings/ai-styles/create",
    edit: "/settings/ai-styles/edit/:id",
    meta: { label: "AI Стили", icon: <ThunderboltOutlined /> },
  },
];
